export default {
  ENTERPRISE: {
    INDEX: {
      PATH: '/b/:businessSlug/enterprise',
      NAME: 'enterprise.index',
    },
    SUBJECTS: {
      INDEX: {
        PATH: '/b/:businessSlug/enterprise/subject-businesses',
        NAME: 'enterprise.subject-businesses',
      },
    },
  },
}
